import { createFileRoute } from "@tanstack/react-router"
import { TrustedDevicesManagementPage } from "@/pages/TrustedDevicesManagementPage"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/security/trusted-devices"
)({
  component: TrustedDevicesManagementPage,
})
